var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlightDocumentsPreliminaryBrief(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 3L18 3V3C18.5523 3 19 3.44772 19 4V4L19 20V20C19 20.5523 18.5523 21 18 21L6 21V21C5.44772 21 5 20.5523 5 20L5 4V4C5 3.44772 5.44772 3 6 3L9 3",
    stroke: "#595959",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 2,
    width: 2,
    height: 6,
    rx: 1,
    transform: "rotate(90 15 2)",
    stroke: "#595959",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 9H15",
    stroke: "#595959",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 12H15",
    stroke: "#595959",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 15H15",
    stroke: "#595959",
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlightDocumentsPreliminaryBrief);
export default __webpack_public_path__ + "static/media/flight-documents-preliminary-brief.05e04bc22a01041e6440610843c8dcc0.svg";
export { ForwardRef as ReactComponent };